import { Navigate, Outlet, useLocation } from "react-router-dom";

/**
 * Route wrapper that protects private routes from unauthenticated access.
 * Redirects to login page if user is not authenticated, preserving the
 * attempted URL for potential redirect after successful login.
 *
 * @param {Object} props - Component props
 * @param {Object} props.auth - Authentication state object
 * @param {boolean} props.auth.isAuthenticated - Whether user is authenticated
 * @returns {JSX.Element} Outlet for child routes or Navigate to login
 */
export const PrivateWrapper = ({ auth: { isAuthenticated } }) => {
  const location = useLocation();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" state={{ from: location.pathname }} replace />;
};

/**
 * Route wrapper for authentication pages that should only be accessible
 * when not logged in (prevents authenticated users from accessing login)
 *
 * @param {Object} props - Component props
 * @param {Object} props.auth - Authentication state object
 * @param {boolean} props.auth.isAuthenticated - Whether user is authenticated
 * @returns {JSX.Element} Outlet for child routes or redirect to dashboard
 */
export const AuthenticatedWrapper = ({ auth: { isAuthenticated } }) => {
  return !isAuthenticated ? <Outlet /> : <Navigate to="/dashboard" replace />;
};
